import { useState, useEffect } from "react";
import SignUpStep1 from "../components/Register/SignUpStep1";
import SignUpStep2 from "../components/Register/SignUpStep2";
import { useNavigate, useLocation } from "react-router-dom";
import SignUpStep3 from "../components/Register/SignUpStep3";

type SignUpData = {
  email: string;
  password: string;
  password2: string;
  name: string;
  profession: string;
  specialty: string;
  edulevel: string;
  receive_newsletter: boolean;
  confirm_health_professional: boolean;
  accept_terms_condition: boolean;
};

export default function SignUp() {
  const [currentStep, setCurrentStep] = useState(1);
  const [signUpData, setSignUpData] = useState<SignUpData>({
    email: "",
    password: "",
    password2: "",
    name: "",
    profession: "Fagprofil",
    specialty: "Speciale",
    edulevel: "",
    receive_newsletter: false,
    confirm_health_professional: false,
    accept_terms_condition: false,
  });

  const nextStep = () => setCurrentStep(currentStep + 1);
  const prevStep = () => setCurrentStep(currentStep - 1);

  const navigate = useNavigate();
  const location = useLocation();

  const [statsData, setStatsData] = useState({
    doctor: 0,
    medstudent: 0,
    nurse: 0,
    other: 0,
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(
          "https://test.doctio.dk/api/statistics/professions"
        );
        const jsonData = await response.json();
        setStatsData(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const emailParam = queryParams.get("email");

    if (emailParam) {
      setSignUpData((prevData) => ({ ...prevData, email: emailParam }));
    }
  }, [location.search]);

  switch (currentStep) {
    case 1:
      return (
        <SignUpStep1
          navigate={navigate}
          nextStep={nextStep}
          statsData={statsData}
          signUpData={signUpData}
          setSignUpData={setSignUpData}
        />
      );
    case 2:
      return (
        <SignUpStep2
          prevStep={prevStep}
          nextStep={nextStep}
          statsData={statsData}
          signUpData={signUpData}
          setSignUpData={setSignUpData}
        />
      );
    case 3:
      return (
        <SignUpStep3
          email={signUpData.email}
          prevStep={prevStep}
          statsData={statsData}
        />
      );

    default:
      return <div>Form Completed!</div>;
  }
}
